type InfoIconProps = {
  size?: number
}

export function InfoIcon({ size = 24 }: InfoIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M9.24939 8.49951C9.64721 8.49951 10.0286 8.65766 10.3099 8.93896C10.5912 9.22027 10.7494 9.60169 10.7494 9.99951V13.7495C11.1636 13.7495 11.4994 14.0853 11.4994 14.4995C11.4994 14.9137 11.1636 15.2495 10.7494 15.2495C10.3516 15.2495 9.97015 15.0914 9.68884 14.8101C9.40754 14.5288 9.24939 14.1473 9.24939 13.7495V9.99951C8.83518 9.99951 8.49939 9.66373 8.49939 9.24951C8.49939 8.8353 8.83518 8.49951 9.24939 8.49951Z" fill="currentColor" />
      <path d="M9.62439 4.74951C10.2457 4.74951 10.7494 5.25319 10.7494 5.87451C10.7494 6.49583 10.2457 6.99951 9.62439 6.99951C9.00307 6.99951 8.49939 6.49583 8.49939 5.87451C8.49939 5.25319 9.00307 4.74951 9.62439 4.74951Z" fill="currentColor" />
      <path d="M9.99939 0.249512C15.3842 0.249512 19.7494 4.61474 19.7494 9.99951C19.7494 15.3843 15.3842 19.7495 9.99939 19.7495C4.61461 19.7495 0.24939 15.3843 0.24939 9.99951C0.24939 4.61474 4.61461 0.249512 9.99939 0.249512ZM9.99939 1.74951C5.44304 1.74951 1.74939 5.44316 1.74939 9.99951C1.74939 14.5559 5.44304 18.2495 9.99939 18.2495C14.5557 18.2495 18.2494 14.5559 18.2494 9.99951C18.2494 5.44316 14.5557 1.74951 9.99939 1.74951Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
    </svg>
  )
}
